<template>
    <div class="container" style="max-width:50rem;">
        <div class="panel panel-default">
            <div class="panel-heading">
                <h2 style="margin:0">Reset Password</h2>
            </div>

            <form name="resetPasswordForm" id="resetPasswordForm">
                <div class="panel-body">
                    <div class="container" style="width: inherit;">
                        <div v-if="tokenIsValid" class="form-group">
                            <div>
                                <label for="newpassword">New Password</label>
                                <input type="password" class="form-control" id="newpassword" name="newpassword" v-model="newPassword" required>
                            </div>
                        </div>

                        <div v-if="tokenIsValid" class="form-group">
                            <div>
                                <label for="confirmpassword">Confirm Password</label>
                                <input type="password" class="form-control" id="confirmpassword" name="confirmpassword" v-model="confirmPassword" required>
                            </div>
                        </div>

                        <div class="alert alert-success" role="alert" v-if="requestSubmitted && tokenIsValid">
                            <span class="glyphicon glyphicon-ok-sign" aria-hidden="true"></span>
                            <span class="sr-only"></span> The password has been reset. Please <a href="/">log in</a> using the new password.
                        </div>

                        <div class="alert alert-danger" role="alert" v-if="!tokenIsValid">
                            <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                            <span class="sr-only"></span>The link is invalid or has expired.
                        </div>

                        <div class="alert alert-danger" role="alert" v-if="error">
                            <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                            <span class="sr-only">Error:</span> {{error}}
                        </div>
                    </div>
                </div>

                <div class="panel-footer" v-if ="tokenIsValid">
                    <div style="text-align: center">
                        <button type="submit" class="btn btn-primary" style="width: 50%;" :disabled="!newPassword||!confirmPassword||requestSubmitted" @click.prevent="reset">Reset Password</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
    import { ref} from 'vue';
    import { useRoute } from 'vue-router';
    import { useUserStore } from '@/stores/user.store'

    const requestSubmitted = ref(false);
    const error = ref('');
    const newPassword = ref('');
    const confirmPassword = ref('');
    const tokenIsValid = ref(true);

    const route = useRoute();
    console.log(route.query);
    const token = route.query.t;

    const store = useUserStore();

    async function reset() {

        requestSubmitted.value = false;
        error.value = '';

       if (await store.validateToken(token)) {
            try {
                await store.resetPasswordFromToken(token, newPassword.value, confirmPassword.value);
                requestSubmitted.value = true;
            }
            catch (e) {
                error.value = e;
                if (e.response?.data?.message) {
                    error.value = e.response.data.message;
                }
            }
       }
       else {
           error.value = 'Token is not valid or email link expired.';
       }
    };

    async function load() {

        tokenIsValid.value = await store.validateToken(token);
    };

    (async () => {
        await load();
    })();
</script>

<style scoped>
  label{
    margin-right: 10px;
    margin-left: 10px;
    font-weight: normal;
  }
  
  .pb-2{
    padding-bottom: 1em;
  }
</style>